import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_ZORSE_INBOXES = createAsyncActionTypes('FETCH_ZORSE_INBOXES');